"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operator = exports.LogicalOperator = void 0;
var LogicalOperator;
(function (LogicalOperator) {
    LogicalOperator["AND"] = "AND";
    LogicalOperator["OR"] = "OR";
})(LogicalOperator = exports.LogicalOperator || (exports.LogicalOperator = {}));
var Operator;
(function (Operator) {
    Operator["STARTS_WITH"] = "startsWith";
    Operator["EQUALS"] = "equals";
    Operator["NOT_EQUALS"] = "notEquals";
    Operator["CONTAINS"] = "contains";
    Operator["MATCHES"] = "matches";
    Operator["EXACTLY_MATCHES"] = "exactlyMatches";
    Operator["EXIST"] = "exist";
    Operator["NOT_EXIST"] = "notExist";
})(Operator = exports.Operator || (exports.Operator = {}));
//# sourceMappingURL=implementation-snippet-trigger-condition.js.map